import * as React from "react";
import { styled } from "@mui/system";
import MUIDrawer from "@mui/material/Drawer";
import { DrawerProps } from "@mui/material/Drawer";

interface DrawerPropsExtended extends DrawerProps {
  width?: number | string;
  component?: React.ElementType;
}

export const Drawer: (props: DrawerPropsExtended) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, DrawerPropsExtended>((props, ref) => (
    <MUIDrawer ref={ref} {...props} />
  )),
  {
    name: "Drawer",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "width" && prop !== "myProp",
    overridesResolver: (props, styles) => []
  }
)(({ theme, width }) => ({
  "&.MuiDrawer-root .MuiDrawer-paperAnchorLeft": {
    background: theme.palette.primary.primary90Color,
    [theme.breakpoints.between("lg", "xl")]: {
      width: 48
    },
    [theme.breakpoints.down("lg")]: {
      width: 248
    }
  },
  "&.MuiDrawer-root .MuiDrawer-paperAnchorLeft .MuiBox-root .MuiIconButton-root .MuiSvgIcon-root":
    {
      color: theme.palette.primary.baseWhiteColor
    },
  "&.MuiDrawer-root .MuiDrawer-paperAnchorLeft .MuiList-root": {
    background: theme.palette.primary.primary90Color
  },
  "&.MuiDrawer-root .MuiDrawer-paperAnchorLeft .MuiList-root .MuiButtonBase-root":
    {
      background: theme.palette.primary.primary90Color,
      ":hover": {
        border: "1px solid transparent",
        background: "rgba(90,104,114,0.48)"
      }
    },
  "&.MuiDrawer-root .MuiDrawer-paperAnchorLeft .MuiList-root .MuiButtonBase-root.Mui-selected":
    {
      background: theme.palette.primary.baseVaporGradient,
      ":hover": {
        border: "1px solid transparent",
        background: theme.palette.primary.baseVaporGradient
      }
    },
  "&.MuiDrawer-root .MuiDrawer-paperAnchorLeft .MuiList-root .MuiButtonBase-root .MuiListItemIcon-root .MuiSvgIcon-root":
    {
      color: theme.palette.primary.baseWhiteColor
    },
  "&.MuiDrawer-root .MuiDrawer-paperAnchorLeft .MuiList-root .MuiButtonBase-root .MuiListItemText-root .MuiTypography-root":
    {
      color: theme.palette.primary.baseWhiteColor
    },
  "&.MuiDrawer-root .MuiDrawer-paperAnchorRight": {
    boxShadow: theme.shadows[2],
    background: theme.palette.primary.surfaceDefault,
    width: width
  }
}));
